import { post } from "storefront/GrailedAPI/request";

type Params = {
  verificationCode: string;
  countryCode: number;
  phoneNumber: number;
  countryAbbreviation: string;
};
/**
 * @name GrailedAPI.v1.Users.Verification.checkVerificationCode
 * @param {Params} params
 * @return {Promise<void>} verifies the SMS code; rejects on failure
 */
const checkVerificationCode: (arg0: Params) => Promise<void> = (params) =>
  post("/api/users/verify_sms_code", params);

export default checkVerificationCode;
